import { Link } from "react-router-dom";
import MarketNavbar from "../MarketNav/MarketNavbar";
import MarketplacePage from "../components/MarketplacePage";
import Usernavbar from "./usernavbar";
import { AccountTitleSkeleton } from "./AccountSkeletons";
import { ACCOUNT } from "../libs/marketplaceRoutes";
import "./UserProfile.css";

const AccountLayout = ({ title, children, loading = false }) => (
  <>
    <MarketNavbar />
    <MarketplacePage className="account-page">
      <nav className="account-mobile-nav" aria-label="Account sections">
        <Link to={ACCOUNT.HOME}>Profile</Link>
        <Link to={ACCOUNT.ORDERS}>Orders</Link>
        <Link to={ACCOUNT.SAVED}>Saved</Link>
        <Link to={ACCOUNT.ADDRESSES}>Addresses</Link>
        <Link to={ACCOUNT.INBOX}>Inbox</Link>
        <Link to={ACCOUNT.REVIEWS}>Reviews</Link>
        <Link to={ACCOUNT.RECENT}>Recent</Link>
        <Link to={ACCOUNT.SETTINGS}>Settings</Link>
      </nav>
      <div className="account-shell">
        <Usernavbar />
        <main className="account-main" aria-busy={loading || undefined}>
          {loading ? (
            <AccountTitleSkeleton />
          ) : (
            title && <h1 className="account-page-title">{title}</h1>
          )}
          {children}
        </main>
      </div>
    </MarketplacePage>
  </>
);

export default AccountLayout;
